import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { ChakraText as Text } from "@airhelp/react-ui-components";

const Paragraph = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Text sx={styles}>{children}</Text>
);

export default Paragraph;
